/**
 * Smellish Geurnoten Tooltips
 * Beschrijvingen voor alle geurnoten - wordt automatisch toegepast op .note-item elementen
 */

const ScentTooltips = {
  // ======================== CITRUS ========================
  "bergamot": "Fris, elegant citrusfruit uit Zuid-Italië met een licht bloemige ondertoon",
  "citroen": "Helder, sprankelend en verkwikkend citrusaroma",
  "limoen": "Scherp, groen en verfrissend met een zesty karakter",
  "sinaasappel": "Zoet, zonnig en vrolijk citrusfruit",
  "mandarijn": "Zachte, zoete citrus met een speelse uitstraling",
  "grapefruit": "Bitter-zoet, energiek en opwekkend",
  "bloedsinaasappel": "Rijke, diepe citrus met rode-fruitaccenten",
  "yuzu": "Japanse citrus met een unieke, aromatische frisheid",
  "cedrat": "Intense, groene citrus met een kruidige kant",
  "pompelmoes": "Groot, sappig en verfrissend citrusfruit",
  "italiaanse-citroen": "Klassieke Amalfi-citroen, zonnig en authentiek",
  "groene-mandarijn": "Onrijpe mandarijn met een groen, fris karakter",
  "kumquat": "Kleine, intense citrus met eetbare schil",
  "citroenverbena": "Kruidig-citrus met een groene, aromatische noot",
  "citrusvruchten": "Mix van zonnige citrusgeuren",
  "pomerans": "Bittere sinaasappel, basis voor eau de cologne",

  // ======================== BLOEMIG ========================
  "roos": "Tijdloze, romantische bloemengeur vol elegantie",
  "jasmijn": "Sensueel, zoet en bedwelmend wit bloemetje",
  "ylang-ylang": "Exotisch, zoet en tropisch bloemig",
  "tuberoos": "Intens, crèmig en verleidelijk wit",
  "gardenia": "Rijk, romig en elegant wit bloemig",
  "magnolia": "Zacht, citrus-bloemig met een frisse uitstraling",
  "pioenroos": "Fris, romantisch en delicaat roze bloemig",
  "iris": "Poederig, elegant en verfijnd met een aardse ondertoon",
  "viooltje": "Poederig, zacht en nostalgisch bloemig",
  "lelie": "Statig, elegant en intens wit bloemig",
  "oranjebloesem": "Zoet, honingachtig en zomers bloemig",
  "frangipani": "Tropisch, crèmig en exotisch bloemig",
  "mimosa": "Poederig, zacht geel en lentachtig",
  "lavendel": "Aromatisch, kalmerend en tijdloos kruidig-bloemig",
  "fresia": "Fris, pepperig en delicaat bloemig",
  "hibiscus": "Tropisch, fruitig-bloemig met een zomerse vibe",
  "lotus": "Waterig, sereen en spiritueel bloemig",
  "orchidee": "Exotisch, crèmig en mysterieus",
  "zwarte-orchidee": "Donker, sensueel en geheimnisvoluit bloemig",
  "lelietje-van-dalen": "Delicaat, fris en lentachtig wit bloemetje",
  "lelietje van dalen": "Delicaat, fris en lentachtig wit bloemetje",
  "hyacint": "Intens, groen-bloemig met een frisse lentegeur",
  "narcis": "Groen, koel en elegant bloemig",
  "narcissen": "Groep voorjaarsbloemen met een frisse, groene geur",
  "jasmijnthee": "Delicate combinatie van thee en jasmijnbloesem",
  "arabische-jasmijn": "Rijke, intense jasmijn uit het Midden-Oosten",
  "damask-roos": "Klassieke, diepe rozensoort uit Damascus",
  "thee-roos": "Elegante roos met een subtiele thee-achtige geur",
  "turkse-roos": "Warme, kruidige rozenvariant",
  "bulgaarse-roos": "Premium roos, rijk en complex",
  "witte-bloemen": "Mix van elegante witte bloemsoorten",
  "appelbloesem": "Fris, lentachtig en onschuldig bloemig",
  "camelia": "Elegant, subtiel en verfijnd bloemig",
  "amaryllis": "Krachtig, elegant en feestelijk bloemig",
  "welriekende-lathyrus": "Zoet, romantisch en nostalgisch bloemig",
  "champaca": "Exotisch, intens en goudgeel bloemig",
  "tahitiaanse-gardenia": "Tropische variant met een crèmige, zoete geur",
  "bourbon-geranium": "Rozig, kruidig met een groene ondertoon",
  "neroli": "Elegant oranjebloesem-extract, fris en verfijnd",
  "heiligenbloem": "Kruidig-bloemig met een zonnige uitstraling",
  "blauwe-lotus": "Mystiek, waterig en spiritueel bloemig",
  "reseda": "Groen, honingachtig en subtiel bloemig",

  // ======================== HOUT ========================
  "sandelhout": "Crèmig, warm en meditatief houtig",
  "cederhout": "Droog, aromatisch en krachtig houtig",
  "vetiver": "Aards, rokerig en diep geworteld",
  "patchoeli": "Aards, kruidig en mysterieus donker",
  "oud": "Kostbaar, dierlijk en intens oosters hout",
  "guaiac-hout": "Rokerig, zoet en medicinaal houtig",
  "eikenhout": "Stevig, klassiek en betrouwbaar houtig",
  "teakhout": "Warm, exotisch en duurzaam houtig",
  "dennenhout": "Fris, bosachtig en verkwikkend groen",
  "berkenhout": "Licht, fris en aromatisch met teerachtige nuances",
  "cypressen": "Groen, fris en mediterraan houtig",
  "cipres": "Aromatisch, groen en eeuwig symbolisch",
  "den": "Fris, harzig en bosrijk groen",
  "ceder": "Warm, droog en majestueus houtig",
  "agarhout": "Zeldzaam, complex en diep aromatisch",
  "thanaka-hout": "Birmaans hout met een zacht, crèmig aroma",
  "droog-hout": "Warm, stoffig en natuurlijk houtig",
  "drijfhout": "Ziltig, verweerd en oceanisch houtig",
  "rode-ceder": "Warm, aromatisch met een roodachtige toon",
  "palissander-rozenhout": "Rozig-houtig, elegant en kostbaar",
  "ceder-uit-virginia": "Amerikaanse ceder, potlood-achtig en droog",
  "witte-ceder-extract": "Zacht, fris en lichthoutig",
  "mahonie": "Rijk, donker en luxueus tropisch hout",
  "akigalahout": "Zeldzaam Japans hout met een unieke geur",
  "berkehout": "Licht, aromatisch en subtiel houtig",
  "amberhout": "Warm, harzig en goudkleurig houtig",
  "witte-houtsoorten": "Lichte, frisse houtmix",
  "houtachtige-noten": "Algemene warme, aardse houtgeuren",

  // ======================== KRUIDEN & SPECERIJEN ========================
  "kaneel": "Warm, zoet en kruidig met een vleugje scherpte",
  "kruidnagel": "Intens, warm en aromatisch kruidig",
  "kardemom": "Fris, aromatisch en licht eucalyptusachtig",
  "gember": "Pittig, warm en verkwikkend",
  "peper": "Scherp, warm en stimulerend kruidig",
  "zwarte-peper": "Krachtig, scherp en verwarmend",
  "roze-peper": "Fruitig, licht en elegant pepperig",
  "nootmuskaat": "Warm, zoet en licht psychedelisch kruidig",
  "saffraan": "Kostbaar, honingachtig en intens kruidig",
  "komijn": "Aards, warm en exotisch kruidig",
  "kurkuma": "Aards, warm en goudgeel kruidig",
  "koriander": "Fris, citrusachtig en aromatisch kruidig",
  "steranijs": "Zoet, anijsachtig en oosters kruidig",
  "bourbon-peper": "Premium peper met een warme, complexe smaak",
  "ceylon-kaneel": "Fijne, zoete kaneel van topkwaliteit",
  "indonesische-nootmuskaat": "Intense, warme nootmuskaatvariant",
  "timur": "Tinteling gevende Nepalese peper",
  "karwijzaad": "Warm, aromatisch en licht anijsachtig",
  "kruidige-noten": "Mix van warme specerijen",

  // ======================== FRUIT ========================
  "appel": "Fris, knapperig en onschuldig fruitig",
  "rode-appel": "Zoet, sappig en verleidelijk rood",
  "peer": "Zacht, zoet en elegant fruitig",
  "perzik": "Fluweelzacht, zoet en zomers fruitig",
  "abrikoos": "Goudgeel, zoet en zonnig fruitig",
  "pruim": "Donker, sappig en rijk fruitig",
  "kers": "Zoet, sappig en romantisch rood",
  "kersen": "Rijpe, sappige rode vruchten",
  "zure-kers": "Pittig, fris en licht zuur fruitig",
  "framboos": "Zoet-zuur, rood en zomers fruitig",
  "braam": "Donker, sappig en bosachtig fruitig",
  "bosbes": "Klein, intens en blauw-paars fruitig",
  "aardbei": "Zoet, rood en onweerstaanbaar fruitig",
  "grote-aardbei": "Sappige, volle aardbeismaak",
  "passievrucht": "Exotisch, tropisch en intens fruitig",
  "mango": "Tropisch, zoet en zonnig fruitig",
  "papaja": "Crèmig, tropisch en zacht fruitig",
  "lychee": "Exotisch, bloemig-fruitig en delicaat",
  "kokosnoot": "Tropisch, crèmig en zomers",
  "vijg": "Zoet, groen en mediterraan fruitig",
  "granaatappel": "Robijnrood, zoet-zuur en antioxidantrijk",
  "sharonvrucht": "Zoet, honingachtig en zacht oranje",
  "watermeloen": "Verfrissend, waterig en zomers",
  "ananas": "Tropisch, zoet-zuur en zonnig",
  "cranberry": "Scherp, rood en fris-zuur",
  "rode-bes": "Klein, fris en helder rood fruitig",
  "moerbei": "Donker, zoet en zeldzaam fruitig",
  "dadels": "Karamelachtig, zoet en oosters fruitig",
  "gesuikerd-fruit": "Gekonfijt, zoet en nostalgisch",

  // ======================== GROEN & AROMATISCH ========================
  "basilicum": "Fris, kruidig en aromatisch groen",
  "munt": "Koel, fris en verkwikkend groen",
  "rozemarijn": "Aromatisch, medicinaal en mediterraan groen",
  "tijm": "Kruidig, warm en aards aromatisch",
  "salie": "Kruidig, grijs-groen en reinigend",
  "groene-thee": "Fris, licht bitter en zen-achtig",
  "gras": "Fris gemaaid, groen en natuurlijk",
  "bamboe": "Fris, groen en oosters sereen",
  "tomatenblad": "Groen, kruidig en zomers aromatisch",
  "dragon": "Anijsachtig, groen en verfijnd kruidig",
  "komkommer": "Waterig, fris en verkoelend groen",
  "klimop": "Groen, fris en natuurlijk bosachtig",
  "schijnhulst": "Groenblijvend, fris en decoratief",
  "lisdodde": "Waterig, groen en moerasachtig fris",
  "groen-accoord": "Frisse, groene bladnoten",
  "cactus": "Groen, waterig en woestijnachtig fris",

  // ======================== HARSEN & BALSEMS ========================
  "wierook": "Heilig, rokerig en spiritueel harsig",
  "mirre": "Bitter, medicinaal en mystiek harsig",
  "benzoine": "Warm, vanilleachtig en balsemisch",
  "amber": "Warm, zoet en sensueel harsig",
  "lichte-amber": "Zachte, goudkleurige warmte",
  "labdanum": "Rijk, leerachtig en amberachtig harsig",
  "olibanum": "Zuivere wierook, heilig en verheffend",
  "elemi": "Fris, citrus-harsig en opwekkend",
  "elemi-hars": "Aromatische boomhars uit de Filipijnen",
  "tolubalsem": "Warm, vanilleachtig en zoet balsemisch",
  "harsen": "Mix van warme, aromatische boomharsen",

  // ======================== MUSK & AMBER ========================
  "muskus": "Sensueel, huidachtig en aantrekkelijk",
  "witte-musk": "Schoon, poederig en zacht sensueel",

  // ======================== ZOET & GOURMAND ========================
  "vanille": "Zoet, warm en troostend",
  "zwarte-vanilleboon": "Intens, rijp en diep vanilleachtig",
  "bourbon-vanille": "Premium Madagaskar vanille, rijk en crèmig",
  "honing": "Gouden, zoet en natuurlijk",
  "karamel": "Gebrand, zoet en verleidelijk",
  "chocolade": "Rijk, bitter-zoet en decadent",
  "cacao": "Puur, intens en ongezoet chocoladeachtig",
  "koffie": "Gebrande bonen, energiek en aromatisch",
  "capuccino": "Romig, koffie met een vleugje melkschuim",
  "marshmallow": "Luchtig, zoet en kinderlijk",
  "suiker": "Puur, kristalhelder zoet",
  "suikerriet": "Natuurlijk, ruw en tropisch zoet",
  "praline-vulling": "Nootachtig, zoet en Belgisch",
  "melk": "Crèmig, zacht en troostend",
  "melk-mousse": "Luchtig, romig en zacht zoet",
  "strawberry-smores": "Kampvuurlekkernij met aardbei",
  "tonkaboon": "Amandel-vanilleachtig, warm en zoet",

  // ======================== LEER & TABAK ========================
  "leer": "Dierlijk, warm en luxueus",
  "tabak": "Droog, gerookt en mannelijk warm",
  "tabaksplantblad": "Groen, vers tabaksblad voor het drogen",

  // ======================== OVERIG ========================
  "zee-noten": "Ziltig, fris en oceanisch",
  "zout": "Mineraal, fris en zeebries-achtig",
  "aldehyden": "Sprankelend, zeepachtig en retro-glamour",
  "calone": "Waterig, fris en oceanisch synthetisch",
  "huid": "Warm, intiem en sensueel",
  "orris-wortel": "Poederig, viooltjesachtig en kostbaar",
  "davana": "Fruitig-kruidig, uniek en complex",
  "cashmeran": "Zacht, muskusachtig en fluwelig warm",
  "sylkolide": "Modern, schoon en muskusachtig",
  "kastanje": "Warm, nootachtig en herfstachtig",
  "amandel": "Zacht, nootachtig en licht zoet",
  "kassieboom": "Kaneelachtig, zoet en aromatisch",
  "jeneverbes": "Fris, gin-achtig en aromatisch",
  "zoethout": "Zoet, anijsachtig en medicinaal",
  "absinth-alsem": "Bitter, kruidig en mysterieus groen",
  "sklareen": "Kruidig, muskusachtig en ontspannend",
  "scharlei": "Aromatisch, kruidig en medicinaal",
  "papyrus": "Droog, papierachtig en antiek",
  "papyrusriet": "Waterig, groen en Egyptisch oud",
  "cognac": "Warm, gedistilleerd en luxueus",
  "drank": "Alcoholisch, warm en feestelijk",
  "cypriol-olie": "Aards, rokerig en oosters houtig",
  "west-indische-laurier": "Kruidig, aromatisch en bay-rum achtig",
  "minerale-noten": "Steenachtig, fris en aards",
  "waterachtige-noten": "Fris, helder en vloeibaar",
  "vlas": "Zacht, natuurlijk en textielachtig",
  "marojaan": "Zoet, kruidig en mediterraan",
  "tahitiaanse-vetiver": "Eiland-vetiver, fris en tropisch",
  "haitiaanse-vetiver": "Aards, rokerig en diep geworteld",
  "bourbon-vetiver": "Premium vetiver, complex en verfijnd",

  // ======================== AANVULLENDE NOTEN ========================
  // Varianten en alternatieve spellingen
  "patchouli": "Aards, kruidig en mysterieus donker",
  "zeenoten": "Ziltig, fris en oceanisch",
  "lychees": "Exotisch, bloemig-fruitig en delicaat",
  "bramen": "Donker, sappig en bosachtig fruitig",
  "denneboom": "Fris, harzig en bosrijk groen",
  "marshmellow": "Luchtig, zoet en kinderlijk",
  "geranium": "Rozig, kruidig met een groene ondertoon",

  // Extra bloemige noten
  "suede": "Zacht, poederig en fluweelachtig warm",
  "mos": "Aards, groen en bosachtig fris",
  "helder-hout": "Licht, fris en transparant houtig",
  "kerkwierook": "Heilig, mystiek en ceremonieel rokerig",
  "bloed-mandarijn": "Diep oranje-rood, intens en zoet citrus",
  "kruidige-geurnoten": "Mix van warme, aromatische specerijen",
  "hout-noten": "Warme, aardse houtmix",
  "indiase-patchouli": "Rijk, intens en donker aards uit India",
  "rood-fruit": "Mix van rijpe rode bessen en vruchten",
  "rabarber": "Fris, zuur-zoet en fruitig groen",
  "oranje-bloesem": "Zoet, honingachtig en zomers bloemig",
  "slagroom": "Romig, zacht en luchtig zoet",
  "zwarte-bes": "Intens, donker en fruitig-groen",
  "plumeria": "Tropisch, crèmig en exotisch Hawaii-bloem",
  "kamperfoelie": "Zoet, honingachtig en nostalgisch bloemig",
  "kasjmier-hout": "Zacht, warm en luxueus houtig",
  "meloen": "Fris, zoet en zomers waterig",
  "guave": "Tropisch, zoet-zuur en exotisch fruitig",
  "waterlelie": "Waterig, fris en sereen bloemig",
  "passiebloem": "Exotisch, bloemig met een tropische vibe",
  "rozenhout": "Rozig-houtig, elegant en subtiel bloemig",
  "anjer": "Kruidig, pepperig en warm bloemig",
  "rode-bessen": "Fris, zoet-zuur en helder rood fruitig",
  "bloedgrapefruit": "Roze-rood, bitter-zoet en sappig citrus",
  "indiase-mandarijn": "Zoet, warm en exotisch citrus",
  "groene-noten": "Fris, bladachtig en natuurlijk groen",
  "viooltjesblad": "Groen, poederig en delicaat bloemig",
  "sering": "Zoet, romantisch en lentachtig paars-bloemig",
  "karo-karounde": "Exotisch, tropisch en intens bloemig",
  "gojibessen": "Zoet-zuur, rood en superfruit-achtig",
  "kweepeer": "Zacht, honingachtig en aromatisch fruitig",
  "vanille-orchidee": "Exotisch, crèmig met vanille-zoetheid",
  "roze-pioen": "Romantisch, fris en elegant roze bloemig",
  "osmanthus": "Abrikoos-achtig, bloemig en Aziatisch",
  "eikenmos": "Aards, bosachtig en groen-houtachtig",
  "mahoniehout": "Rijk, warm en roodbruin luxe hout",
  "olijfboom": "Groen, mediterraan en aromatisch houtachtig",
  "maninka": "Tropisch, fruitig en exotisch Afrikaans",
  "fruitige-noten": "Mix van zoete, sappige vruchten",
  "afrikaanse-oranjebloesem": "Intens, zoet en exotisch bloemig",
  "amalfi-citroen": "Italiaanse citroen, zonnig en authentiek",
  "cassis": "Intens, donker en zoet-zuur besachtig",
  "heliotroop": "Zoet, amandel-vanilleachtig en poederig bloemig",
  "iriswortel": "Poederig, viooltjesachtig en kostbaar",
  "styrax": "Warm, balsemisch en harsachtig zoet",
  "tabaksblad": "Groen, vers en aromatisch bladachtig",
  "laurierblad": "Aromatisch, kruidig en mediterraan groen",
  "ambergris": "Ziltig, dierlijk en oceanisch warm",
  "roze-grapefruit": "Zoet-bitter, roze en verfrissend citrus",
  "siciliaanse-bergamot": "Fris, elegant en Italiaans citrus",
  "patchouli-uit-singapore": "Verfijnd, oosters en rijk aards",
  "civet": "Dierlijk, muskusachtig en sensueel",
  "zwart-viooltje": "Donker, mysterieus en intens bloemig",
  "chinotto": "Bitter-zoet, citrus en Italiaans aromatisch",
  "madagascar-peper": "Warm, exotisch en intens pepperig",
  "pepperwood": "Houtig, kruidig met een peppernoot",
  "calabrische-bergamot": "Zuivere, frisse Zuid-Italiaanse citrus",
  "waternoten": "Fris, helder en aquatisch",
  "vijgenblad": "Groen, melkachtig en mediterraan fris",
  "grapefruit-bloesem": "Delicaat, citrus-bloemig en fris",
  "rode-besblad": "Groen, fris met een rode-bes ondertoon",

  // ======================== AANVULLING (31 aug 2026) ========================
  // Alle noten die wel op een product in Shopify stonden maar hier nog geen
  // beschrijving hadden. Die toonden de terugvaltekst 'Een kenmerkende noot
  // in deze geur.' Sleutels volgen exact de handle uit main-product.liquid:
  // strip, remove ™, downcase, spatie naar koppelteken, apostrof weg.
  "aardse-noten": "Vochtige aarde, wortels en bos na de regen",
  "abricoosbloesem": "Zachte abrikozenbloesem, fruitig-bloemig en fluweelzacht",
  "afrikaanse-oranjebloem": "Zonnige oranjebloesem met een romige, honingzoete kern",
  "agarhout-(oud)": "Kostbaar oosters hout, rokerig, dierlijk en balsemisch diep",
  "amandelmelk": "Zacht, romig notig en licht zoet",
  "amber-xtreme": "Extreem krachtige amber, droog, houtig en mineralig",
  "ambermax": "Intense amberbasis, warm, houtig en zeer persistent",
  "ambrette": "Plantaardige muskus uit hibiscuszaad, poederig en licht wijnachtig",
  "ambrettezaad": "Zacht plantaardig muskuszaad, poederig warm en huidachtig",
  "ambrofix": "Zuivere amber-molecuul, warm, droog en langhoudend",
  "ambroxan": "Warm, zacht amberachtig met een schone, huidachtige gloed",
  "anijs": "Zoet, licht koel en dropachtig kruidig",
  "appelbrandewijn": "Gestookte appel, warm fruitig met een alcoholische gloed",
  "aquatische-noten": "Waterig fris, luchtig en helder",
  "aquozone": "Marien molecuul met een frisse, ozonachtige zeegeur",
  "arabische-jasmijn-(sambac)": "Intens witte jasmijn, zoet en bedwelmend met een groene kant",
  "aronskelk": "Koele, groene bloem met een waterig-elegante uitstraling",
  "artemisia": "Bitter kruidig alsem, groen en licht medicinaal",
  "atlasceder": "Droog, potloodachtig ceder met een harsige warmte",
  "balsem-spar": "Zachte naaldboom, harsig fris met een zoete kant",
  "belambraboom": "Warm, harsig hout met een ambergrijze diepte",
  "benzoïne": "Zoet balsemhars met een vanille-achtige warmte",
  "berk": "Rokerig, teerachtig hout met een leerachtige toon",
  "bessen": "Sappig rood fruit, zoetzuur en levendig",
  "bijenwas": "Warm, honingzoet en licht dierlijk zacht",
  "bittere-amandel": "Marsepeinachtig, intens zoet met een amaretto-kant",
  "blauwe-hyacint": "Groen-bloemig, waterig fris met een kruidige scherpte",
  "blauwe-regen": "Zoete, honingachtige trosbloesem met een groene frisheid",
  "blauweregen": "Zoete, honingachtige trosbloesem met een groene frisheid",
  "bleke-iris": "Koel, poederig en aards elegant",
  "bloed-sinaasappel": "Diepe, donkerrode sinaasappel met bessenachtige zoetheid",
  "bloemen": "Bloemig boeket, zacht en veelzijdig",
  "bloemige-noten": "Bloemig akkoord dat het hart van de geur draagt",
  "braziliaans-rozenhout": "Zacht houtig met een roosachtige, licht kruidige gloed",
  "bruine-suiker": "Warme, melassezoete suiker met een licht rokerige kant",
  "cacao-dop": "Droge cacaoschil, bitter chocoladeachtig en licht rokerig",
  "cactusbloem": "Groen, waterig en licht zoet woestijnbloemig",
  "calamondin": "Kleine Filipijnse citrus, bitterzoet en pittig fris",
  "cashmere-hout": "Zacht, warm en fluweelachtig houtig",
  "castoreum": "Dierlijk, leerachtig en rokerig warm",
  "chinese-jasmijn": "Verfijnde jasmijn, thee-achtig fris en licht zoet",
  "citroen-meringue-taart": "Zure citroen op zoet schuimgebak, fris en romig tegelijk",
  "citroenbloesem": "Delicate bloesem van de citroenboom, fris en licht honingzoet",
  "citroenrasp": "De geraspte schil: scherp, olieachtig en intens citrus",
  "citroenschil": "Bittere, olierijke schil met een levendige frisheid",
  "citruswater": "Verdunde, luchtige citrus met een waterige helderheid",
  "crème-brûlée": "Vanillecustard met een gebrande suikerkorst",
  "cumarine": "Hooiachtig zoet met een amandel- en tonkakant",
  "cupcake": "Vers gebak, boterachtig zoet met een vanillekant",
  "cyclamen": "Frisse, waterig-groene bloem met een licht poederige kant",
  "dauwdruppels": "Waterig fris, doorschijnend en licht groen",
  "doornappel": "Nachtbloeier met een zware, bedwelmend zoete geur",
  "dragee": "Suikerlaagje om een amandel, knapperig en zoet",
  "druiven": "Sappig, wijnachtig zoet met een fluwelen schil",
  "ebbenhout": "Donker, dicht hout met een rokerige diepte",
  "egyptische-jasmijn": "Weelderige jasmijn, warm bloemig en licht dierlijk",
  "eik": "Robuust, droog hout met een tannine-achtige kant",
  "engelwortel": "Aards, kruidig-groen met een licht muskusachtige diepte",
  "foelie": "Fijne, warme specerij rond de nootmuskaat, zoet en houtig",
  "franse-labdanum": "Donker, leerachtig hars met een amberzoete diepte",
  "franse-narcis": "Groen, hooiachtig bloemig met een licht dierlijke diepte",
  "fruitpunch": "Uitbundige mix van tropisch en rood fruit, zoet en sprankelend",
  "galbanum-(gomhars)": "Snijdend groen hars, bitter en intens plantaardig",
  "geconfijte-amandel": "Gesuikerde amandel, knapperig zoet en notig",
  "gekonfijte-citroen": "Gesuikerde citroenschil, zoet en licht karamelachtig",
  "gele-jasmijn": "Zoete gele bloem met een honingachtige, warme gloed",
  "gemberbloem": "Exotisch bloemig met een pittige, gemberachtige tinteling",
  "geroosterde-koffiebonen": "Donker gebrand, bitter en intens aromatisch",
  "gin": "Fris jeneverbes-kruidig met een droge, alcoholische scherpte",
  "goudsbloem": "Kruidig-bloemig met een licht harsige, zonnige warmte",
  "gourmand-akkoord": "Eetbaar zoet akkoord van suiker, vanille en gebak",
  "granny-smith-appel": "Scherp zure groene appel, knisperend fris",
  "grapefruitbloesem": "Bloesem van de grapefruit, bitterzoet en licht bloemig",
  "grenadine": "Zoete granaatappelsiroop, rood fruitig en stroperig",
  "groen-gras": "Vers gemaaid gras, sappig groen en zomers",
  "groene-amandel": "Onrijpe amandel, groen, licht bitter en fris",
  "groene-appel": "Knapperig, zuur-fris en sappig groen",
  "groene-sering": "Sering met een groene, waterige frisheid",
  "groene-theebladeren": "Fris, grasachtig en licht bitter groen",
  "grond-tinctuur": "Natte aarde en wortels, rauw en mineralig",
  "gustaviabloem": "Tropische bloem, romig wit en zwoel zoet",
  "hazelnoot": "Warm geroosterd, notig en licht boterachtig",
  "haïtiaanse-vetiver": "Verfijnde vetiver, rokerig, grapefruitachtig fris en aards",
  "hedione": "Doorschijnende jasmijnfrisheid die de geur opent en luchtig maakt",
  "heilig-hout-(palo-santo)": "Rokerig, harsig hout met een zoete, spirituele gloed",
  "heliotroop-(vanillebloem)": "Amandel-vanilleachtig bloemig, poederig en zacht",
  "hooi": "Gedroogd gras, warm zoetig met een cumarine-achtige kant",
  "ijsblokjes": "Koel, helder en bijna geurloos fris",
  "indiase-tuberoos": "Weelderige tuberoos, boterachtig romig en intens wit",
  "indonesisch-patchouliblad": "Rijke Indonesische patchouli, aards, houtig en licht zoet",
  "iso-e-super": "Fluweelzacht houtig-amberachtig, bijna onmerkbaar en huidachtig",
  "italiaanse-jasmijn": "Zonnige jasmijn, zacht zoet en romig wit",
  "italiaanse-mandarijn": "Zachte, zoete mandarijn met een zonnige uitstraling",
  "jasmijn-sambac": "Rijke, honingzoete jasmijn met een fruitige ondertoon",
  "jeneverstruik": "Hars-achtige bes, fris naaldbomig en licht peperig",
  "kardemom-uit-guatemala": "Verfijnde kardemom, fris kruidig met een citrusachtige kant",
  "karwij": "Warm, aards kruidig met een anijsachtige scherpte",
  "kassia": "Krachtige kaneelsoort, warm zoet en licht scherp",
  "katoenbloem": "Zacht, schoon en poederig als vers wasgoed",
  "kauwgom": "Zoet, fruitig en nostalgisch synthetisch",
  "kersenbloesem": "Tere, licht amandelachtige bloesem, zoet en vluchtig",
  "kiwi": "Groen, licht zuur en waterig fris",
  "klaver": "Groen weiland met honingzoete, kruidige ondertoon",
  "klokjesbloem": "Delicaat, groen bloemig en licht honingzoet",
  "koenjit": "Kurkuma, aards warm met een peperige bitterheid",
  "kokoshout": "Romig houtig met een zachte, tropische zoetheid",
  "kokosmelk": "Romig, zacht en tropisch zoet",
  "kokoswater": "Licht, waterig kokos met een frisse zoetheid",
  "kool": "Groene, aardse en licht zwavelige groentenoot",
  "kruidnagelen": "Warm, pittig en licht verdovend zoet",
  "kulfi": "Indiaas roomijs, romig zoet met kardemom en pistache",
  "laurier": "Aromatisch kruidig blad, warm en licht balsemisch",
  "lavendel-extract": "Geconcentreerde lavendel, kruidig fris en licht kamferachtig",
  "lindebloesem": "Honingzoete zomerbloesem met een groene, thee-achtige kant",
  "louro-amarelo-hout": "Braziliaans geel hout, warm en licht kruidig houtig",
  "macarons": "Amandelgebak, zoet, licht en poederig",
  "madagascar-vanille": "Rijke bourbonvanille, romig zoet en warm",
  "madagascar-vetiver": "Rokerig, aards vetiver met een grasachtige frisheid",
  "madonnalelie": "Zuivere witte lelie, groen bloemig en licht wasachtig",
  "mahonial": "Zacht houtig-amberachtig met een fluwelen warmte",
  "mandarijnblad": "Groen blad van de mandarijnboom, bitterfris en kruidig",
  "marokkaanse-roos": "Warme, kruidige roos met een honingachtige diepte",
  "massoia-hout": "Romig kokosachtig hout, zacht en melkachtig zoet",
  "mastiekhars": "Mediterraan hars, groen, harsig en licht dennig",
  "mate-(ilex-paraguariensis)": "Zuid-Amerikaanse kruidenthee, groen, rokerig en licht bitter",
  "meidoorn": "Amandelachtige voorjaarsbloesem, zoet en licht poederig",
  "meiroos": "Zachte lenteroos, honingzoet met een groene frisheid",
  "metaalachtige-noten": "Koel, scherp en metalig helder",
  "mirabelle-pruim": "Kleine gele pruim, honingzoet en sappig",
  "mirte": "Mediterraan kruid, fris groen met een eucalyptusachtige kant",
  "moepel-(mimusops-zeyheri)": "Zuid-Afrikaanse vrucht en bloesem, zoet en licht abrikoosachtig",
  "muskus-ambrette": "Zachte muskus met een poederige, licht fruitige kant",
  "nashi-peer": "Japanse peer, knapperig, waterig en subtiel zoet",
  "nectarine": "Sappige steenvrucht, zoet met een fluweelzachte frisheid",
  "neroli-(oranjebloesem)": "Bloesem van de bittere sinaasappel, honingzoet en zonnig",
  "neroli-extract": "Geconcentreerde oranjebloesem, warm bloemig en licht groen",
  "olibanum-(kerkwierook)": "Heilig wierookhars, rokerig, citrusachtig en verheffend",
  "opoponax": "Zoet mirre-achtig hars, warm, balsemisch en licht rokerig",
  "oriëntaalse-noten": "Warm, kruidig en balsemisch oosters akkoord",
  "orris-(wortelextract)": "Kostbaar irisextract, poederig, wortelachtig en fluweelzacht",
  "orris-wortel-(iris-germanica)": "Iriswortel, aards poederig met een violette elegantie",
  "oud-(agarwood)": "Donker, harsig oosters hout, rokerig en intens warm",
  "palissander--en-rozenhout": "Warm edelhout, roosachtig zacht en licht kruidig",
  "panacotta": "Romig, melkachtig zoet met een zachte vanilletoon",
  "paprikapoeder": "Droog, warm rood en licht zoet kruidig",
  "parma-viooltje": "Poederig, zoet en nostalgisch bloemig",
  "patchouliblad": "Aards, donker groen met een licht kamferachtige kant",
  "peer-bloesem": "Tere perenbloesem, licht fruitig en poederig bloemig",
  "pelargonium": "Geranium-achtig, groen roosachtig met een muntige frisheid",
  "peru-balsem": "Warm balsemhars, vanille-achtig zoet met een rokerige kant",
  "perzikbloesem": "Tere roze bloesem, licht fruitig en poederig",
  "petalia": "Bloemig-fruitige noot met een frisse, roosachtige helderheid",
  "petitgrain": "Takjes en blad van de bittere sinaasappel, groen en houtig fris",
  "piment": "Kruidnagel, kaneel en nootmuskaat in een noot, warm en zoet pittig",
  "pistache": "Zacht groen notig, romig en licht zoet",
  "pistache-nootjes": "Geroosterde pistache, notig zoet en romig",
  "pittosporeae": "Oranjebloesemachtige bloesem, zoet en zonnig wit",
  "pittosporum": "Zoete, oranjebloesemachtige bloesem met een groene frisheid",
  "pomarose": "Roos en gedroogd fruit ineen, warm zoet en licht honingachtig",
  "pomme-damour-(suikerappel)": "Appel in een glanzende suikerlaag, kermiszoet en fruitig",
  "praline": "Gekaramelliseerde noten, zoet en boterachtig warm",
  "praliné": "Gekaramelliseerde noten, zoet, warm en romig",
  "praliné-vulling": "Zachte notenvulling, romig zoet en chocoladeachtig",
  "provençaalse-roos": "Zonnige Franse roos, fris bloemig en licht groen",
  "pruimenlikeur": "Rijpe pruim op alcohol, donker zoet en fluweelzacht",
  "rangoon-klimmer": "Tropische klimbloem, zoet bloemig met een honingachtige gloed",
  "rijst": "Zacht, poederig en licht melkachtig graan",
  "rijstbloem": "Zacht, poederig en licht melkachtig bloemig",
  "rode-amber": "Warme, kruidige amber met een harsige diepte",
  "rode-bessen-(aalbes)": "Scherp, zuur-zoet rood fruit met een knappende frisheid",
  "rode-cyclamen": "Cyclamen met een warmere, fruitig-bloemige toon",
  "rode-lychees": "Exotisch, roosachtig zoet en sappig tropisch",
  "rode-piment": "Warme, zoete specerij met een peperige gloed",
  "rode-pioenroos": "Weelderig bloemig, fruitig fris en licht peperig",
  "romige-karamel": "Boterachtige, gesmolten suiker met een zachte diepte",
  "rook": "Rokerig, warm en licht verbrand houtachtig",
  "roomijs": "Koel, melkachtig en zacht vanillezoet",
  "rosa-damascena": "De klassieke parfumroos, rijk, fluweelzacht en licht fruitig",
  "rose-freesia": "Sprankelend bloemig, peperig fris met een roze zoetheid",
  "roze-roos": "Zachte, romantische roos met een fruitige zoetheid",
  "rozenblaadjes": "Tere, licht poederige roos, zacht en romantisch",
  "rozenbottel": "Vrucht van de wilde roos, fruitig-zuur met een tere bloemigheid",
  "rozenwater": "Verdunde roos, fris, schoon en doorschijnend bloemig",
  "rum": "Warm, zoet en licht rokerig met een karamelkant",
  "selderij-zaden": "Kruidig, aards en licht bitter groen",
  "sesamzaad": "Geroosterd, notig en licht olieachtig",
  "shisoplant-(japanse-netel)": "Japans kruid tussen munt en basilicum, groen en licht anijsachtig",
  "siamese-benzoine": "Zoete Thaise benzoë, vanilleachtig en warm balsemisch",
  "sichuan-peper": "Tintelend citrus-peperig met een verdovende scherpte",
  "siciliaanse-citroen": "Zonnige Italiaanse citroen, helder en sappig fris",
  "siciliaanse-citroenbladeren": "Groene citroenbladeren, kruidig-fris en bitter",
  "siciliaanse-mandarijn": "Rijpe mandarijn uit Sicilie, zoet en sappig",
  "sinaasappelschil": "Olierijke schil, bitterzoet en aromatisch",
  "snoepnoten": "Speels suikergoed, zoet en kunstmatig fruitig",
  "spar": "Fris naaldbomig, harsig en koel groen",
  "sparhars": "Kleverig naaldhars, balsemisch en groen warm",
  "specerijen": "Warm kruidig akkoord van peper, kaneel en nootmuskaat",
  "strawberry-s’mores": "Geroosterde marshmallow, chocolade en aardbei, kampvuurzoet",
  "sukadecitroen": "Dikke, geurige citroenschil met een zoetig-harsige kant",
  "suède": "Zacht, poederig leer met een fluwelen huidgevoel",
  "thee": "Droog, aromatisch en licht tanninerijk",
  "theeblad": "Droog, groen en licht tanninerijk",
  "tiaré-tahiti": "Tropische witte bloem, romig zoet en zonnig",
  "truffel": "Aards, dierlijk en intens paddenstoelachtig",
  "tuberoos-(nachthyacint)": "Zware witte bloem die 's nachts opent, romig en bedwelmend",
  "tutti-frutti": "Speels snoepachtig fruit, zoet en kleurrijk",
  "vanille-absolute": "Geconcentreerde vanille, donker, balsemisch en intens",
  "vanille-caviar": "Het merg uit de vanillepeul, puur, romig en intens",
  "vanillepeul": "Hele vanillepeul, warm, houtig zoet en rond",
  "venkel": "Zoet anijsachtig kruid, groen en licht kruidig",
  "vergeet-me-nietjes": "Tere blauwe bloem, licht fris en onopvallend zoet",
  "vijgeblad": "Groen, melkachtig en mediterraan met een bittere kant",
  "viooltjes-bladeren": "Groen, waterig en licht bitter bladachtig",
  "viooltjes-wortel": "Aards, poederig en irisachtig met een fluwelen kant",
  "virginia-ceder": "Droog, scherp ceder met een potloodachtige kant",
  "virginiaanse-ceder": "Droog Amerikaans ceder, houtig scherp en helder",
  "vruchten": "Sappig, zoet fruitig akkoord",
  "vuursteen": "Droog mineralig, rokerig als steen op steen",
  "water-jasmijn": "Doorschijnende jasmijn, fris en waterig licht",
  "water-noten": "Fris, helder en aquatisch licht",
  "waterfruit": "Waterig, licht en verfrissend fruitig akkoord",
  "waterkers": "Peperig groen met een frisse, waterige scherpte",
  "whiskey": "Warm, houtig en rokerig met een zoete graankant",
  "wilde-bessen": "Donker bosfruit, zoetzuur en licht aards",
  "wit-hout": "Licht, schoon en luchtig houtig",
  "wit-viooltje": "Zacht poederig viooltje, fris en licht groen",
  "witte-amber": "Lichte, schone amber, zacht warm en poederig",
  "witte-camelia": "Subtiel wit bloemig, thee-achtig en licht wasachtig",
  "witte-ceder": "Licht, schoon ceder met een luchtige houtigheid",
  "witte-chocola": "Romig, boterachtig zoet met een melkkant",
  "witte-chocolade": "Zacht, melkachtig zoet met cacaoboter",
  "witte-honing": "Zachte, bloemige honing zonder de zware zoetheid",
  "witte-muskus": "Schoon, zacht en huidachtig warm",
  "witte-nerium-oleander": "Zoete mediterrane bloesem met een groene, licht bittere kant",
  "witte-peer": "Zachte, sappige peer met een frisse zoetheid",
  "witte-peper": "Droog, prikkelend en verfijnd pittig",
  "witte-perzik": "Zacht, romig en delicaat zoet steenfruit",
  "witte-roos": "Koele, zuivere roos met een groene, elegante kant",
  "witte-thee": "Delicaat, licht bloemig en bijna doorschijnend fris",
  "wodka": "Zuiver, koud en scherp alcoholisch",
  "yuzu-(japanse-citroen)": "Japanse citrus tussen mandarijn en grapefruit, fris en aromatisch",
  "zeebries": "Frisse zeewind, zilt en luchtig open",
  "zeewater": "Zilt, koel en oceanisch fris",
  "zeewier": "Zilt, groen en licht jodiumachtig marien",
  "zeezout": "Mineralig zilt met een droge, frisse scherpte",
  "zemelen": "Droog graan, notig en licht meelachtig",
  "zwarte-thee": "Rokerig droog, tanninerijk en warm"
};

// Automatisch tooltips toepassen wanneer DOM geladen is
document.addEventListener('DOMContentLoaded', function() {
  applyNoteTooltips();
});

// Functie om tooltips toe te passen op alle note elementen
function applyNoteTooltips() {
  // Selecteer alle note-item elementen
  const noteElements = document.querySelectorAll('.note-item');

  noteElements.forEach(el => {
    // Haal de note naam uit de class (note-bergamot -> bergamot)
    const classes = el.className.split(' ');
    const noteClass = classes.find(c => c.startsWith('note-') && c !== 'note-item');

    if (noteClass) {
      const noteName = noteClass.replace('note-', '');
      const tooltip = ScentTooltips[noteName];
      const currentTooltip = el.getAttribute('data-tooltip') || '';

      // Overschrijf als we een tooltip hebben EN de huidige tooltip is
      // leeg of bevat alleen de naam van de noot (geen echte beschrijving)
      const noteText = el.textContent.trim();
      const needsTooltip = !currentTooltip ||
                          currentTooltip === noteText ||
                          currentTooltip.length < 30;

      if (tooltip && needsTooltip) {
        el.setAttribute('data-tooltip', tooltip);
        el.classList.add('tooltip-note');
      }
    }
  });
}

// Maak functie globaal beschikbaar voor dynamische content
window.applyNoteTooltips = applyNoteTooltips;
window.ScentTooltips = ScentTooltips;
